module.exports = __webpack_public_path__ + "static/media/logo.86dbd775.svg";